// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class DispatcherVersionMessage implements flatbuffers.IUnpackableObject<DispatcherVersionMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DispatcherVersionMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDispatcherVersionMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: DispatcherVersionMessage,
  ): DispatcherVersionMessage {
    return (obj || new DispatcherVersionMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsDispatcherVersionMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: DispatcherVersionMessage,
  ): DispatcherVersionMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DispatcherVersionMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  version(): string;
  version(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  version(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startDispatcherVersionMessage(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addVersion(builder: flatbuffers.Builder, versionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, versionOffset, 0);
  }

  static endDispatcherVersionMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // version
    return offset;
  }

  static createDispatcherVersionMessage(
    builder: flatbuffers.Builder,
    versionOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    DispatcherVersionMessage.startDispatcherVersionMessage(builder);
    DispatcherVersionMessage.addVersion(builder, versionOffset);
    return DispatcherVersionMessage.endDispatcherVersionMessage(builder);
  }

  unpack(): DispatcherVersionMessageT {
    return new DispatcherVersionMessageT(this.version());
  }

  unpackTo(_o: DispatcherVersionMessageT): void {
    _o.version = this.version();
  }

  unpackFields(...fields: string[]): DispatcherVersionMessageT {
    const t = new DispatcherVersionMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("version")) {
      t.version = this.version();
    }
    return t;
  }
}

export class DispatcherVersionMessageT implements flatbuffers.IGeneratedObject {
  constructor(public version: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.version === null || this.version === undefined) {
      throw new Error('Required field "version" is not set');
    }
    const version = this.version !== null ? builder.createString(this.version!) : 0;

    return DispatcherVersionMessage.createDispatcherVersionMessage(builder, version);
  }

  clone(): DispatcherVersionMessageT {
    const obj = new DispatcherVersionMessageT();
    obj.version = this.version;
    return obj;
  }

  equals(other: DispatcherVersionMessageT): boolean {
    if (this.version !== other.version) return false;
    return true;
  }
}

export function verifyDispatcherVersionMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "version");
  } finally {
    verifier.popDepth();
  }
}
